import { useState } from "react";
import { Heart, Leaf, Wind, Coffee } from "lucide-react";
import { sound } from "@/lib/sound";

const PATTERNS = [
  { id: "heart", Icon: Heart, name: "Heart", nameKr: "하트" },
  { id: "leaf", Icon: Leaf, name: "Rosetta", nameKr: "로제타" },
  { id: "swirl", Icon: Wind, name: "Swirl", nameKr: "스월" },
];

export default function LatteArt({ world, onWin }) {
  const [target] = useState(() => PATTERNS[Math.floor(Math.random() * PATTERNS.length)]);
  const [wrong, setWrong] = useState(null);
  const [over, setOver] = useState(false);
  const TIcon = target.Icon;

  const pour = (id) => {
    if (id === target.id) {
      sound.playGift();
      onWin();
    } else {
      setWrong(id);
      sound.playError();
      setTimeout(() => setWrong(null), 500);
    }
  };

  return (
    <div className="text-center">
      <p className="text-sm text-white/70">Pour the matching foam onto the cup — tap it, or drag it in.</p>
      <div
        className="mt-4 inline-flex items-center gap-2 rounded-full border px-4 py-2"
        style={{ borderColor: `${world.accent}55` }}
      >
        <span className="text-xs uppercase tracking-widest text-white/50">Match</span>
        <TIcon className="h-5 w-5" style={{ color: world.accent }} />
        <span className="text-sm text-white">{target.name}</span>
        <span className="kr text-xs text-white/45">{target.nameKr}</span>
      </div>

      <div
        onDragOver={(e) => {
          e.preventDefault();
          setOver(true);
        }}
        onDragLeave={() => setOver(false)}
        onDrop={(e) => {
          e.preventDefault();
          setOver(false);
          const id = e.dataTransfer.getData("id");
          if (id) pour(id);
        }}
        data-testid="latte-cup"
        className="mx-auto mt-6 flex h-40 w-40 items-center justify-center rounded-full border-2 transition-all"
        style={{
          borderColor: over ? world.accent : "rgba(255,255,255,0.2)",
          background: "radial-gradient(circle at 50% 35%, rgba(255,255,255,0.08), rgba(0,0,0,0.45))",
          boxShadow: over ? `0 0 30px ${world.accentSoft}` : "none",
        }}
      >
        <Coffee className="h-16 w-16 text-white/40" />
      </div>

      <div className="mt-6 flex justify-center gap-4">
        {PATTERNS.map((p) => {
          const I = p.Icon;
          return (
            <button
              key={p.id}
              draggable
              onDragStart={(e) => e.dataTransfer.setData("id", p.id)}
              onClick={() => pour(p.id)}
              data-testid={`foam-${p.id}`}
              className={`flex h-16 w-16 flex-col items-center justify-center rounded-2xl border transition-all hover:scale-105 ${
                wrong === p.id ? "animate-pulse" : ""
              }`}
              style={{
                borderColor: wrong === p.id ? "#ef4444" : `${world.accent}40`,
                background: "rgba(255,255,255,0.04)",
              }}
            >
              <I className="h-6 w-6" style={{ color: world.accent }} />
              <span className="mt-1 text-[0.6rem] text-white/60">{p.name}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
